/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Note_ClearedInputs */

const en_us2_exercise_personal_note_cleared = /** @type {(inputs: Exercise_Personal_Note_ClearedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note deleted`)
};

const pt_br2_exercise_personal_note_cleared = /** @type {(inputs: Exercise_Personal_Note_ClearedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota apagada`)
};

const es_419_exercise_personal_note_cleared = /** @type {(inputs: Exercise_Personal_Note_ClearedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota eliminada`)
};

const pt_pt2_exercise_personal_note_cleared = /** @type {(inputs: Exercise_Personal_Note_ClearedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota apagada`)
};

const fr_fr2_exercise_personal_note_cleared = /** @type {(inputs: Exercise_Personal_Note_ClearedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note supprimée`)
};

const de_de2_exercise_personal_note_cleared = /** @type {(inputs: Exercise_Personal_Note_ClearedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiz gelöscht`)
};

const it_it2_exercise_personal_note_cleared = /** @type {(inputs: Exercise_Personal_Note_ClearedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota eliminata`)
};

/**
* | output |
* | --- |
* | "Note deleted" |
*
* @param {Exercise_Personal_Note_ClearedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_note_cleared = /** @type {((inputs?: Exercise_Personal_Note_ClearedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Note_ClearedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_note_cleared(inputs)
	if (locale === "es-419") return es_419_exercise_personal_note_cleared(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_note_cleared(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_note_cleared(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_note_cleared(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_note_cleared(inputs)
	return en_us2_exercise_personal_note_cleared(inputs)
});
export { exercise_personal_note_cleared as "exercise-personal.note_cleared" }